import { render, staticRenderFns } from "./StatsSummary.vue?vue&type=template&id=e6133ab2&scoped=true&"
import script from "./StatsSummary.vue?vue&type=script&lang=ts&"
export * from "./StatsSummary.vue?vue&type=script&lang=ts&"
import style0 from "./StatsSummary.vue?vue&type=style&index=0&id=e6133ab2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6133ab2",
  null
  
)

export default component.exports